/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from 'react';

import useAutosizeTextArea from '../../core/hooks/useAutosizeTextArea';
import { CustomInputInterface } from '../../core/models/inputs';

interface Props {
  id: string;
  name: string;
  label?: string;
  max?: number;
  input: CustomInputInterface;
  emptyMessage?: string;
  invalidMessage?: string;
  className?: string;
  rows?: number;
  onKeyDown?: any;
}

function CustomTextarea({
  id,
  name,
  label,
  input,
  max,
  emptyMessage,
  invalidMessage,
  className,
  rows,
  onKeyDown,
}: Props) {
  useAutosizeTextArea(input.ref.current, input.value);
  const error = useMemo(
    () => (!input.showError ? '' : input.isEmpty ? 'empty' : !input.isValid ? 'invalid' : ''),
    [input.showError, input.isEmpty, input.isValid],
  );
  return (
    <div className={`input${!error ? '' : ' error'}${!className ? '' : ` ${className}`}`}>
      <div className="input__wrapper">
        {!label ? null : (
          <label className="input__label body-label" htmlFor={id}>
            {label}
          </label>
        )}
        <textarea
          id={id}
          name={name}
          value={input.value}
          onChange={input.onChange as any}
          placeholder=""
          className="input__field"
          maxLength={max}
          ref={input.ref}
          rows={rows}
          onKeyDown={onKeyDown}
        />
      </div>
      {!error || (!emptyMessage && !invalidMessage) ? null : (
        <div className="input__error">
          <span>
            {error === 'empty' ? emptyMessage : error === 'invalid' ? invalidMessage : ''}
          </span>
        </div>
      )}
    </div>
  );
}

export default CustomTextarea;
